import { action } from 'satcheljs/lib/legacy';
import EditorViewState from '../store/schema/EditorViewState';

export default action('setIsDirty')(function setIsDirty(
    viewState: EditorViewState,
    isDirty: boolean
) {
    viewState.isDirty = isDirty;
});
